import { IIconBase } from '..'

const toAssignIcon = ({
  color = '#333752',
  height = 14,
  width = 14,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/personalcard'>
        <g id='personalcard'>
          <path
            id='Vector'
            d='M9.91675 12.25H4.08341C1.75008 12.25 1.16675 11.6667 1.16675 9.33333V4.66667C1.16675 2.33333 1.75008 1.75 4.08341 1.75H9.91675C12.2501 1.75 12.8334 2.33333 12.8334 4.66667V9.33333C12.8334 11.6667 12.2501 12.25 9.91675 12.25Z'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M8.16675 4.6665H11.0834'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M8.75 7H11.0833'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M9.91675 9.3335H11.0834'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_5'
            d='M4.95842 6.58579C5.54154 6.58579 6.01425 6.11307 6.01425 5.52995C6.01425 4.94683 5.54154 4.47412 4.95842 4.47412C4.3753 4.47412 3.90259 4.94683 3.90259 5.52995C3.90259 6.11307 4.3753 6.58579 4.95842 6.58579Z'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_6'
            d='M7.00008 9.52602C6.91841 8.68019 6.24758 8.01519 5.40175 7.93936C5.11008 7.91019 4.81258 7.91019 4.51508 7.93936C3.66925 8.02102 2.99841 8.68019 2.91675 9.52602'
            stroke={color}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default toAssignIcon
